module.exports = __webpack_public_path__ + "bounceInLeft.gif";